import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{ marginTop: "6rem" }} className="img">
      <div className="row justify-content-center text-center">
        <div className="col-md-10 col-lg-8">
          <div className="header-section">
            <h2 className="display-6 text-center pb-5 mb-4">
              Privacy <b>Policy</b>
            </h2>
          </div>
        </div>
      </div>
      {/* <img
        src="/assets/1.png"
        className="img-fluid rounded mx-auto d-block mb-5"
        alt="Responsive"
      /> */}

      <div className="container">
        <p><strong>Effective Date:</strong> May 20, 2025  <strong>Last Updated:</strong> May 20, 2025</p>
        <h4>1. Information We Collect</h4>
        <p>
          We may collect the following types of information:
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, phone number, and any information you voluntarily provide.</li>
            <li><strong>Usage Data:</strong> Pages visited, time spent on pages, clicks, and interactions.</li>
            <li><strong>Social Media Data:</strong> If you interact with our app via Facebook, Instagram, or LinkedIn, we may access your public profile, posts, and other information per your platform permissions.</li>
          </ul>
        </p>

        <h4>2. How We Use Your Information</h4>
        <p>We use the collected data to:</p>
        <ul>
          <li>Provide and improve our services</li>
          <li>Communicate with you</li>
          <li>Analyze usage trends</li>
          <li>Personalize your experience</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h4>3. Sharing Your Information</h4>
        <p>We do <strong>not</strong> sell or rent your personal information. We may share your data with:</p>
        <ul>
          <li>Third-party service providers (for analytics, hosting, etc.)</li>
          <li>Legal authorities if required by law</li>
          <li>Social media platforms, only if you authorize it</li>
        </ul>

        <h4>4. Cookies and Tracking</h4>
        <p>We use cookies and similar technologies to:</p>
        <ul>
          <li>Improve user experience</li>
          <li>Track website performance</li>
          <li>Enable social media integrations</li>
        </ul>
        <p>You can control cookies through your browser settings.</p>

        <h4>5. Data Retention</h4>
        <p>We retain your data only as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required or permitted by law.</p>

        <h4>6. Data Deletion Request</h4>
        <p>
          You can request that we delete your personal data at any time.
          <br />
          <strong>Submit a Request:</strong> <a href="https://bytlasintelligence.com/data-deletion">https://bytlasintelligence/data-deletion</a><br />
          Or email us at: <strong>info@bytlasintelligence.com.com</strong>
        </p>

        <h4>7. Security</h4>
        <p>We implement industry-standard security measures to protect your data. However, no method of transmission or storage is 100% secure.</p>

        <h4>8. Children's Privacy</h4>
        <p>Our services are not intended for children under the age of 13. We do not knowingly collect data from minors.</p>

        <h4>9. Changes to This Policy</h4>
        <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting a notice on our website.</p>

        <h4>10. Contact Us</h4>
        <p>
          If you have questions or concerns about this Privacy Policy, please contact us:
          <br />
          📧 <strong>Email:</strong> info@bytlasintelligence.com.com
          <br />
          🌐 <strong>Website:</strong> <a href="https://bytlasintelligence.com">www.bytlasintelligence.com</a>
        </p>
      </div>
    </div>
  );
}
